// extracted by mini-css-extract-plugin
export var childrenContainer = "_dl-0";
export var virtualScrollArea = "_dl-1";